import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import TextArea from 'antd/lib/input/TextArea';
import './style.css';
import moment from 'moment';
import { GetIncomeStatementData, UpdateAccountsCommentNotes, UpdateAccountsQuestion, MarkAsReviewed } from '../../../../appRedux/actions/IncomeStatementAction';
import { bindActionCreators } from 'redux';
import CircularProgress from '../../../../components/CircularProgress';
import { GetLastQuarterEndDate, makeLinkForQuickbooks } from '../../../common/commonServices';
import { GetLastQuarterGLReviewedDate } from '../../../../appRedux/actions/BalanceSheetAction'
import { toast } from 'react-toastify';

class IncomeStatementReviewPage extends Component {
  constructor(props) {
    super(props);

    this.sDateRef = React.createRef();
    this.eDateRef = React.createRef();

    // End date = Last Quarter End Date
    let eDate = GetLastQuarterEndDate();
    // Start date = January 1st of the same year as eDate
    let sDate = new Date(eDate.getFullYear(), 0, 1);

    this.state = {
      eDate: eDate,
      sDate: sDate,
      ACMethod: 'Accrual',
      loading: false,
      accountData: [],
      selectedAccountId: -1,
      editedData: null,
      expandedAccountTypes: [],
      collapsedParentAccountKeys: [],
      companyId: 0,
      reportDate: null,
      reviewedDate: null,
      grossProfit: 0,
      netOperatingIncome: 0,
      netOtherIncome: 0,
      netProfit: 0,
      dataLoaded: false,
      stReviewedDate: null,
      sortOrder: 'A'
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('userData'));
    if (!user || !user.companyId) return;

    // Set companyId and dispatch the Redux action to get the last quarter reviewed date
    this.setState({ companyId: user.companyId }, () => {
      this.props.GetLastQuarterGLReviewedDate(user.companyId);
    });
  }

  getAccountTypeOrder = (type) => {
    const normalizedType = this.normalizeAccountType(type);
    const sectionOrder = {
      Income: 1,
      "Cost of Goods Sold": 2,
      Expenses: 3,
      "Other Income": 4,
      "Other Expenses": 5
    };
    return sectionOrder[normalizedType] || 99;
  }

  normalizeAccountType = (type) => {
    if (!type) return "";
    const rawType = String(type).trim();
    const compact = rawType.replace(/\s+/g, "").toLowerCase();

    if (compact === "costofgoodssold") return "Cost of Goods Sold";
    if (compact === "expense" || compact === "expenses") return "Expenses";
    if (compact === "otherexpense" || compact === "otherexpenses") return "Other Expenses";
    if (compact === "otherincome") return "Other Income";
    if (compact === "income") return "Income";

    return rawType;
  }

  loadIncomeStatementData = () => {
    const param = this.getIncomeStatementReportData();
    this.setState({ loading: true });
    this.props.GetIncomeStatementData(param);
  }

  mapIncomeStatementAccount = (acc) => ({
    AccountId: acc.accountId,
    AccountName: acc.name,
    Balance: acc.amount,
    AccountNum: acc.accountNum,
    Description: acc.description,
    Notes: acc.notes,
    Question: acc.questions,
    questionId: acc.questionId,
    ReportDate: acc.reportDate,
    ListID: acc.listID,
    ParentRefListID: acc.parentRefListID,
    SubAccount: acc.subAccount,
    Level: acc.level || 0,
    HasChildren: !!(acc.hasChildren || (acc.children && acc.children.length)),
    Children: (acc.children || []).map(this.mapIncomeStatementAccount)
  })

  componentDidUpdate(prevProps) {
    // Handle GLReviewLastQueterDate update (set eDate from API response)
    if (this.props.GLReviewLastQueterDate !== prevProps.GLReviewLastQueterDate) {
      if (this.props.GLReviewLastQueterDate && this.props.GLReviewLastQueterDate.transactionStatus === 0) {
        // Extract the date from returnObject
        const dateFromAPI = this.props.GLReviewLastQueterDate.returnObject;
        const eDate = dateFromAPI != null ? new Date(dateFromAPI) : GetLastQuarterEndDate();
        // Calculate sDate as January 1st of the same year as eDate
        const sDate = new Date(eDate.getFullYear(), 0, 1);

        // Update state with the eDate, sDate and reviewedDate, then load data
        this.setState({ eDate: eDate, sDate: sDate, reviewedDate: eDate }, () => {
          this.loadIncomeStatementData();
        });
      } else if (this.props.GLReviewLastQueterDate && this.props.GLReviewLastQueterDate.transactionStatus !== 0) {
        // If API fails, use fallback date
        const fallbackDate = GetLastQuarterEndDate();
        const sDate = new Date(fallbackDate.getFullYear(), 0, 1);
        this.setState({ eDate: fallbackDate, sDate: sDate }, () => {
          this.loadIncomeStatementData();
        });
      }
    }

    if (this.props.IncomeStatementData !== prevProps.IncomeStatementData) {
      const data = this.props.IncomeStatementData && this.props.IncomeStatementData.returnObject.incomeStatementAccountsSummaryDataList;
      if (data) {
        const mappedData = data.map(typeObj => ({
          AccountType: this.normalizeAccountType(typeObj.type),
          Accounts: (typeObj.accounts || []).map(this.mapIncomeStatementAccount),
          Total: typeObj.total
        }));

        const orderedData = [...mappedData].sort((a, b) => {
          const orderDiff = this.getAccountTypeOrder(a.AccountType) - this.getAccountTypeOrder(b.AccountType);
          if (orderDiff !== 0) return orderDiff;
          return (a.AccountType || "").localeCompare(b.AccountType || "");
        });
        const allTypes = orderedData.map(typeObj => typeObj.AccountType);

        this.setState({
          accountData: orderedData,
          loading: false,
          expandedAccountTypes: allTypes,
          collapsedParentAccountKeys: [],
          reportDate: this.props.IncomeStatementData.returnObject.reportDate,
          //reviewedDate: this.props.IncomeStatementData.returnObject.reviewedDate,
          stReviewedDate: this.props.IncomeStatementData.returnObject.stReviewedDate,
          grossProfit: this.props.IncomeStatementData.returnObject.grossProfit ? this.props.IncomeStatementData.returnObject.grossProfit : 0,
          netOperatingIncome: this.props.IncomeStatementData.returnObject.netOperatingIncome ? this.props.IncomeStatementData.returnObject.netOperatingIncome : 0,
          netOtherIncome: this.props.IncomeStatementData.returnObject.netOtherIncome ? this.props.IncomeStatementData.returnObject.netOtherIncome : 0,
          netProfit: this.props.IncomeStatementData.returnObject.netProfit,
          dataLoaded: true
        });
      } else {
        this.setState({
          accountData: [],
          loading: false,
          expandedAccountTypes: [],
          collapsedParentAccountKeys: [],
          reportDate: null,
          reviewedDate: null,
          grossProfit: 0,
          netOperatingIncome: 0,
          netOtherIncome: 0,
          dataLoaded: true
        });
      }
    }
  }

  toggleSortOrder = () => {
    this.setState(prevState => ({
      sortOrder: prevState.sortOrder === 'A' ? 'D' : 'A'
    }));
  }

  getSortedAccounts = (accounts) => {
    if (!accounts || !accounts.length) return [];

    const normalizeNum = (val) => {
      if (val === null || val === undefined) return '';
      return String(val).trim();
    };

    const normalizeName = (val) => {
      if (val === null || val === undefined) return '';
      return String(val).trim();
    };

    const sorted = [...accounts].sort((a, b) => {
      const numA = normalizeNum(a.AccountNum);
      const numB = normalizeNum(b.AccountNum);
      const hasNumA = numA !== '' && numA !== '0';
      const hasNumB = numB !== '' && numB !== '0';

      if (hasNumA !== hasNumB) {
        return hasNumA ? -1 : 1;
      }

      if (hasNumA && hasNumB) {
        const numCompare = numA.localeCompare(numB, undefined, { numeric: true, sensitivity: 'base' });
        if (numCompare !== 0) return numCompare;
      }

      const nameA = normalizeName(a.AccountName);
      const nameB = normalizeName(b.AccountName);
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    });
    return this.state.sortOrder === 'D' ? sorted.reverse() : sorted;
  }

  getAccountRowKey = (account, typeIndex, path) => {
    return `${typeIndex}_${path}_${account.AccountId || account.ListID || account.AccountName}`;
  }

  // Default: all parents expanded. Track only collapsed keys so sort order cannot break expand-all.
  collectParentAccountKeys = (sections) => {
    const keys = [];
    const walk = (accounts, typeIndex, path) => {
      const sortedAccounts = this.getSortedAccounts(accounts);
      (sortedAccounts || []).forEach((account, idx) => {
        const key = this.getAccountRowKey(account, typeIndex, `${path}${idx}`);
        if (account.HasChildren && account.Children && account.Children.length) {
          keys.push(key);
          walk(account.Children, typeIndex, `${path}${idx}_`);
        }
      });
    };
    (sections || []).forEach((section, typeIndex) => walk(section.Accounts, typeIndex, ''));
    return keys;
  }

  getAccountRollupBalance = (account) => {
    const direct = parseFloat(account.Balance) || 0;
    if (!account.Children || !account.Children.length) return direct;
    return direct + account.Children.reduce((sum, child) => sum + this.getAccountRollupBalance(child), 0);
  }

  getAccountTypeRollupTotal = (accounts) => {
    return (accounts || []).reduce((sum, acc) => sum + this.getAccountRollupBalance(acc), 0);
  }

  // QBO-style: parent rows with no own amount stay blank; leaf $0.00 still shows.
  formatAccountBalanceDisplay = (account, hasChildren) => {
    const balance = parseFloat(account.Balance);
    if (hasChildren && (!balance || balance === 0)) {
      return "";
    }
    return `$${this.numberWithCommas(account.Balance)}`;
  }

  getAccountIndentPx = (level) => {
    return 30 + (level || 0) * 30;
  }

  isParentAccountExpanded = (key) => {
    return this.state.collapsedParentAccountKeys.indexOf(key) === -1;
  }

  toggleParentAccount = (key, event) => {
    if (event) {
      event.stopPropagation();
    }
    let items = [...this.state.collapsedParentAccountKeys];
    if (this.isParentAccountExpanded(key)) {
      items.push(key);
    } else {
      items.splice(items.indexOf(key), 1);
    }
    this.setState({ collapsedParentAccountKeys: items });
  }

  formatAccountLabel = (account) => {
    const num = account.AccountNum;
    const name = account.AccountName;
    if ((num === null || num === undefined || num === 0 || num === "0" || num === "") && (!name || name === "")) {
      return "";
    }
    if ((num === null || num === undefined || num === 0 || num === "0" || num === "")) {
      return name || "";
    }
    if (!name || name === "") {
      return num;
    }
    return `${num} - ${name}`;
  }

  renderAccountRows = (accounts, typeIndex, path = '') => {
    // Single path so leaf-only children arrays still use account.Level for padding.
    return this.getSortedAccounts(accounts).map((account, accountIndex) => {
      const rowPath = `${path}${accountIndex}`;
      const rowKey = this.getAccountRowKey(account, typeIndex, rowPath);
      const hasChildren = !!(account.HasChildren && account.Children && account.Children.length);
      const level = account.Level || 0;
      const indent = this.getAccountIndentPx(level);
      const isExpanded = !hasChildren || this.isParentAccountExpanded(rowKey);

      return (
        <React.Fragment key={rowKey}>
          <tr
            className={`account-type-row${hasChildren ? ' account-parent-row' : ''}`}
            onClick={() => hasChildren ? this.toggleParentAccount(rowKey) : this.handleAccountClick(account)}
            style={{}}
          >
            <td className="is-account-name-col" style={{ paddingLeft: `${indent}px` }}>
              {hasChildren && (
                <span
                  className="is-parent-toggle"
                  onClick={(e) => this.toggleParentAccount(rowKey, e)}
                  style={{ marginRight: "6px" }}
                >
                  {isExpanded ? (
                    <i className="zmdi zmdi-minus-circle-outline" style={{ fontSize: "20px", fontWeight: "bold", color: "#349683" }}></i>
                  ) : (
                    <i className="zmdi zmdi-plus-circle-o" style={{ fontSize: "20px", fontWeight: "bold", color: "#334c5a" }}></i>
                  )}
                </span>
              )}
              {this.formatAccountLabel(account)}
            </td>
            <td className="text-right">
              {this.formatAccountBalanceDisplay(account, hasChildren)}
            </td>
            <td>{!hasChildren ? (account.Notes || "") : ""}</td>
            <td>{!hasChildren ? (account.Question || "") : ""}</td>
          </tr>

          {!hasChildren && this.state.selectedAccountId === account.AccountId && (
            <tr className="income-statement-edit-row" key={`edit_${rowKey}`}>
              <td colSpan="2">&nbsp;</td>
              <td>
                Internal Notes :
                <TextArea
                  placeholder="Enter Notes"
                  onChange={this.handleNotesChange}
                  value={this.state.editedData ? this.state.editedData.Notes : ""}
                  className="textarea-box"
                />
                <div style={{ padding: "10px" }}>
                  <Button className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowUpdateClick(account.questionId)}>SAVE</Button>
                  <Button className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancelClick()}>CANCEL</Button>
                </div>
              </td>
              <td>
                Questions and Comments for the Client:
                <TextArea
                  placeholder="Enter Questions"
                  onChange={this.handleQuestionChange}
                  value={this.state.editedData ? this.state.editedData.question : ""}
                  className="textarea-box"
                />
              </td>
            </tr>
          )}

          {hasChildren && isExpanded && this.renderAccountRows(account.Children, typeIndex, `${rowPath}_`)}

          {hasChildren && isExpanded && (
            <tr className="account-parent-subtotal-row" key={`subtotal_${rowKey}`}>
              <td style={{ paddingLeft: `${indent}px`, fontWeight: "bold" }}>
                Total for {account.AccountName}
              </td>
              <td className="text-right" style={{ fontWeight: "bold" }}>
                ${this.numberWithCommas(this.getAccountRollupBalance(account))}
              </td>
              <td colSpan="2"></td>
            </tr>
          )}
        </React.Fragment>
      );
    });
  }

  ApplyDate = () => {
    this.loadIncomeStatementData();
  }

  isAccountTypeExpanded = (accountType) => {
    return this.state.expandedAccountTypes.indexOf(accountType) > -1;
  }

  toggleAccountType = (accountType) => {
    let items = [...this.state.expandedAccountTypes];
    if (this.isAccountTypeExpanded(accountType)) {
      items.splice(items.indexOf(accountType), 1);
    } else {
      items.push(accountType);
    }
    this.setState({ expandedAccountTypes: items, selectedAccountId: -1, editedData: null });
  }

  handleAccountClick = (account) => {
    if (this.state.selectedAccountId === account.AccountId) {
      this.setState({ selectedAccountId: -1, editedData: null });
    } else {
      let editData = {
        AccountId: account.AccountId,
        Notes: account.Notes,
        question: account.Question,
      };
      this.setState({ selectedAccountId: account.AccountId, editedData: editData });
    }
  }

  handleNotesChange = (event) => {
    let ed = { ...this.state.editedData };
    ed.Notes = event.target.value;
    this.setState({ editedData: ed });
  }

  handleQuestionChange = (event) => {
    let ed = { ...this.state.editedData };
    ed.question = event.target.value;
    this.setState({ editedData: ed });
  }

  onRowUpdateClick = function (id) {
    var rowEditedData = this.state.editedData ? this.state.editedData : {};

    var accountId = (rowEditedData.AccountId !== null && rowEditedData.AccountId !== undefined)
      ? rowEditedData.AccountId
      : 0;

    var questionBody = {
      accountID: accountId,
      question: rowEditedData.question ? rowEditedData.question : "",
      companyID: this.state.companyId ? this.state.companyId : 0,
      cpaReview: false,
      id: id ? id : 0,
      status: false
    };

    var notesBody = {
      AccountId: accountId,
      Comments: rowEditedData.Notes ? rowEditedData.Notes : ""
    };

    this.setState({ loading: true });

    Promise.all([
      this.props.UpdateAccountsQuestion(questionBody),
      this.props.UpdateAccountsCommentNotes(notesBody)
    ]).then(() => {
      this.loadIncomeStatementData();
      this.setState({ selectedAccountId: -1, editedData: null });
    });

  }.bind(this);

  onRowCancelClick = () => {
    this.setState({ editedData: null, selectedAccountId: -1 });
  }

  numberWithCommas = (x) => {
    if (x === null || x === undefined || x === '') return '0.00';
    return parseFloat(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  //Used for Datepicker — focus the picker that matches which calendar icon was clicked
  handleFocus = (e, selecter) => {
    const control = selecter === 'sDate' ? this.sDateRef : selecter === 'eDate' ? this.eDateRef : null;
    if (control && control.current != null) {
      control.current.setFocus();
    }
  }

  //Used for Datepicker
  handleDateChange = (e, target) => {
    if (target === "fromDate") {
      this.setState({ sDate: new Date(e), selectedDateRange: { startDate: moment(new Date(e)).format("MM/DD/YYYY"), endDate: moment(this.state.eDate).format("MM/DD/YYYY") } })
    }
    else if (target === "uptoDate") {
      const newEDate = new Date(e);
      // When eDate changes, recalculate sDate as January 1st of that year
      const newSDate = new Date(newEDate.getFullYear(), 0, 1);
      this.setState({ eDate: newEDate, sDate: newSDate, selectedDateRange: { startDate: moment(newSDate).format("MM/DD/YYYY"), endDate: moment(newEDate).format("MM/DD/YYYY") } })
    }
  }

  handleFormChange = (e) => {
    if (e.target.name === "accountingMethod") {
      this.setState({ ACMethod: e.target.value });
    }
  }

  //Used for redirect to the Quickbook Profit and Loss Statement
  redirectToProfitAndLoss = () => {
    const qboBaseUrl = makeLinkForQuickbooks();
    const url = `${qboBaseUrl}/app/reportv2?token=PANDL`;
    window.open(url, '_blank');
  }

  getIncomeStatementReportData = () => {
    const { companyId, sDate, eDate, ACMethod } = this.state;

    let param = "companyId=" + companyId +
      "&fromDate=" + moment(sDate).format("MM/DD/YYYY") +
      "&toDate=" + moment(eDate).format("MM/DD/YYYY") +
      "&AccountingMethod=" + ACMethod;
    return param;
  }

  markAsReviewed = () => {
    const { companyId, sDate, eDate, ACMethod } = this.state;

    const body = {
      CompanyID: companyId,
      AccountingMethod: ACMethod,
      FromDate: moment(sDate).format("MM/DD/YYYY"),
      ToDate: moment(eDate).format("MM/DD/YYYY")
    };

    this.props
      .MarkAsReviewed(body)
      .then(() => {
        toast.success("Income Statement marked as reviewed.");
        this.loadIncomeStatementData();
        this.setState({ selectedAccountId: -1, editedData: null });
      })
      .catch((error) => {
        toast.error('Error while marking as reviewed:', error);
      });
  };

  ViewArchived = () => {
    this.props.history.push("reviewedISList");
  }

  render() {
    return (
      <div className="dashboardPage income-statement-review-screen">
        <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
          <h2 className="title mb-3 mb-sm-0 income-statement-review-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Income Statement Review</h2>
        </div>

        <div className="padding-box app-wrapper padding-b0">
          <div className="row">

            {/* Left Side Date Section — match Balance Sheet filter card layout */}
            <div className="col-12 col-md-4">
              <div className="dashboard-box " style={{ flexWrap: "wrap" }}>
                <div className="datepicker-box">
                  <div style={{ textAlign: "left" }}>
                    <label className="pl-2">From :</label>
                    <div className="date-box">
                      <DatePicker
                        selected={this.state.sDate}
                        onChange={(e) => this.handleDateChange(e, 'fromDate')}
                        name="fromDate"
                        id="date"
                        required={true}
                        margin="normal"
                        disabledKeyboardNavigation
                        showMonthDropdown
                        showYearDropdown
                        yearDropdownItemNumber={15}
                        maxDate={this.state.eDate}
                        ref={this.sDateRef}
                      />
                      <div className="date-icon" onClick={(e) => this.handleFocus(e, 'sDate')}>
                        <i className="zmdi zmdi-calendar-note"></i>
                      </div>
                    </div>
                  </div>

                  <div className="to-box">
                    <span className="text-center ledgerto-text">To</span>
                  </div>

                  <div style={{ textAlign: "left" }}>
                    <label className="pl-2">&nbsp;</label>
                    <div className="date-box">
                      <DatePicker
                        selected={this.state.eDate}
                        onChange={(e) => this.handleDateChange(e, 'uptoDate')}
                        name="uptoDate"
                        id="date"
                        required={true}
                        margin="normal"
                        showMonthDropdown
                        showYearDropdown
                        yearDropdownItemNumber={15}
                        disabledKeyboardNavigation
                        minDate={this.state.sDate}
                        maxDate={new Date()}
                        ref={this.eDateRef}
                      />
                      <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                        <i className="zmdi zmdi-calendar-note"></i>
                      </div>
                    </div>
                  </div>

                  <div style={{ textAlign: "left" }}>
                    <label className="pl-4">A/C Method</label>
                    <div className="date-box" style={{ padding: "0px 20px" }}>
                      <Select name="accountingMethod" required={true} native value={this.state.ACMethod} onChange={this.handleFormChange} >
                        <option value={""} disabled>Select Accouting Method</option>
                        {/* <option value={"Cash"}>Cash</option> */}
                        <option value={"Accrual"}>Accrual</option>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="genera-apply-btn" style={{ marginTop: "10px", textAlign: "left" }}>
                  <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >Apply</Button>
                </div>
              </div>
            </div>

            {/* Right Side Button Section */}
            <div className="col-12 col-md-8">
              <div className="btncheck_compare">
                <div className="float-right d-flex align-items-center gap-3">

                  {/* <div className="qbo-profit-loss d-flex align-items-center">
                    <span className="qbo-label">Profit & Loss</span>
                    <img
                      id='qbo-label'
                      alt="Open QBO Profit & Loss"
                      className="icon-img ml-2 cursor-pointer"
                      src="/vendors/Link-gray.png"
                      onClick={() => this.redirectToProfitAndLoss()}
                      onMouseOver={e => (e.currentTarget.src = "/vendors/Link-darkBlue.png")}
                      onMouseOut={e => (e.currentTarget.src = "/vendors/Link-gray.png")}
                    />
                  </div> */}

                  <Button
                    variant="contained"
                    className="jr-btn refresh-btn"
                    onClick={() => this.redirectToProfitAndLoss()}
                    style={{ backgroundColor: '#003a75', color: '#ffffff', textTransform: 'none', padding: '6px 12px' }}
                  >
                    Profit & Loss
                    <img
                      src={`${process.env.PUBLIC_URL}/vendors/Link-gray.png`}
                      alt="review icon"
                      style={{ width: 20, height: 20, marginLeft: 8, filter: 'invert(1) brightness(400%)' }}
                    />
                  </Button>
                  <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.markAsReviewed()}> Mark as Reviewed </Button>
                  <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn view-btn" onClick={() => this.ViewArchived()}>View History</Button>
                </div>
              </div>

              <div className="float-right" style={{ marginTop: "20px" }}>
                {this.state.reportDate && this.state.stReviewedDate && (
                  <p>
                    Last Income Statement report as on <b>{moment(this.state.reportDate).format("MM-DD-YYYY")}</b> was reviewed on{" "}<br />
                    {/* <b>{moment(this.state.ReviewedDate).format("MM-DD-YYYY")} at {moment(this.state.ReviewedDate).format("hh:mm A")}</b>. */}
                    <b>{this.state.stReviewedDate}</b>

                  </p>
                )}
              </div>
            </div>

          </div>
        </div>


        {/* Table Section - Show the Income Statement Accounts Details */}

        {this.state.loading ? (
          <div className="is-loading-wrap">
            <CircularProgress></CircularProgress>
          </div>
        ) : this.state.dataLoaded && this.state.accountData.length === 0 ? (
          <div className="padding-box app-wrapper account-reconcilliation balancereview-page income-statement-review-page">
            <div className="is-empty-wrap">
              No Data Found
            </div>
          </div>
        ) : this.state.dataLoaded ? (
          <React.Fragment>
            <div className="padding-box app-wrapper account-reconcilliation balancereview-page income-statement-review-page" style={{ paddingTop: "0px" }}>
              <div className="table-responsive-material">
                <table className="table balance-sheet-page fixed-table" >
                  <thead className="panel-bg white_header_text">
                    <tr>
                      <th
                        className={`width-300 is-account-name-col ${this.state.sortOrder === 'A' ? 'asending' : 'desending'}`}
                        style={{ cursor: "pointer" }}
                        onClick={this.toggleSortOrder}
                      >
                        <p className="table-th-title">Account No.</p>
                      </th>
                      <th className="td-width type-td-width text-right" >Balance</th>
                      <th>Internal Notes</th>
                      <th>Questions and Comments for the Client</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.accountData.map((accountType, typeIndex) => (
                      <React.Fragment key={`type_${typeIndex}`}>
                        {/* Account Type Header */}
                        <tr
                          className="account-type-header"
                          onClick={() => this.toggleAccountType(accountType.AccountType)}
                          style={{}}
                        >
                          <td colSpan="4">
                            <span>
                              {this.isAccountTypeExpanded(accountType.AccountType) ? (
                                <i className="zmdi zmdi-minus-circle-outline" style={{ marginRight: "8px", fontSize: "22px", fontWeight: "bold", color:"#349683" }}></i>
                              ) : (
                                <i className="zmdi zmdi-plus-circle-o" style={{ marginRight: "8px", fontSize: "22px", fontWeight: "bold", color:"#334c5a" }}></i>
                              )}
                            </span>
                            &nbsp;&nbsp;{accountType.AccountType}{["Expense", "Other Expense"].includes(accountType.AccountType) ? "s" : ""}
                          </td>
                        </tr>

                        {/* Accounts within Type */}
                        {this.isAccountTypeExpanded(accountType.AccountType) &&
                          <>
                            {this.renderAccountRows(accountType.Accounts, typeIndex)}

                            {/* ✅ Total Row for Each Account Type */}
                            <tr className="account-total-row" style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
                              <td style={{ paddingLeft: "20px", fontWeight: "bold" }}>
                                Total {accountType.AccountType}{["Expense", "Other Expense"].includes(accountType.AccountType) ? "s" : ""}
                              </td>
                              <td className="text-right" style={{ fontWeight: "bold" }}>
                                ${this.numberWithCommas(
                                  accountType.Total != null
                                    ? accountType.Total
                                    : this.getAccountTypeRollupTotal(accountType.Accounts)
                                )}
                              </td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        }

                        {accountType.AccountType === "Cost of Goods Sold" && (
                          <tr className="net-profit-row">
                            <td className="net-profit-label">Gross Profit</td>
                            <td className="text-right net-profit-amount">
                              {"$" + (this.state.grossProfit < 0
                                ? "-" + this.numberWithCommas(Math.abs(this.state.grossProfit))
                                : this.numberWithCommas(this.state.grossProfit))}
                            </td>
                            <td colSpan="2"></td>
                          </tr>
                        )}

                        {accountType.AccountType === "Expenses" && (
                          <tr className="net-profit-row">
                            <td className="net-profit-label">Net Operating Income</td>
                            <td className="text-right net-profit-amount">
                              {"$" + (this.state.netOperatingIncome < 0
                                ? "-" + this.numberWithCommas(Math.abs(this.state.netOperatingIncome))
                                : this.numberWithCommas(this.state.netOperatingIncome))}
                            </td>
                            <td colSpan="2"></td>
                          </tr>
                        )}

                        {accountType.AccountType === "Other Expenses" && (
                          <tr className="net-profit-row">
                            <td className="net-profit-label">Net Other Income</td>
                            <td className="text-right net-profit-amount">
                              {"$" + (this.state.netOtherIncome < 0
                                ? "-" + this.numberWithCommas(Math.abs(this.state.netOtherIncome))
                                : this.numberWithCommas(this.state.netOtherIncome))}
                            </td>
                            <td colSpan="2"></td>
                          </tr>
                        )}

                      </React.Fragment>
                    ))}

                    <tr className="net-profit-row">
                      <td className="net-profit-label">Net Profit</td>
                        <td className="text-right net-profit-amount">
                          {"$" + (this.state.netProfit < 0
                            ? "-" + this.numberWithCommas(Math.abs(this.state.netProfit))
                            : this.numberWithCommas(this.state.netProfit))}
                        </td>
                      <td colSpan="2"></td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </React.Fragment>
        ) : null}



      </div>
    );
  }
}



const mapStateToProps = (state) => ({
  IncomeStatementData: state.IncomeStatement.IncomeStatementData,
  GLReviewLastQueterDate: state.BalanceSheetData.GLReviewLastQueterDate
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    GetIncomeStatementData,
    UpdateAccountsCommentNotes,
    UpdateAccountsQuestion,
    MarkAsReviewed,
    GetLastQuarterGLReviewedDate,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(IncomeStatementReviewPage);
